<template>
  <v-row>
    <v-col cols="12" md="4">
      <v-text-field
        class="mb-4"
        hide-details
        :label="placeholderText || $vuetify.lang.t('$vuetify.SEARCH_BY_NAME')"
        aria-label="Search"
        append-icon="mdi-magnify"
        @input="searchDidChange"
        @keyup.enter="onSearchClick()"
      >
        <v-icon slot="append" @click="onSearchClick()">mdi-magnify</v-icon>
      </v-text-field>
    </v-col>
    <v-col cols="12" :md="slotCols" class="d-flex align-center">
      <slot />
    </v-col>
  </v-row>
</template>
<script>
import { mapMutations } from 'vuex'
import { EventBus } from '@/event-bus.js'

export default {
  name: 'Searchbar',
  props: {
    placeholderText: {
      type: String,
      required: false,
      default: ''
    },
    slotCols: {
      type: String,
      required: false,
      default: '8'
    }
  },
  methods: {
    ...mapMutations('app', ['setSearchString']),
    searchDidChange(val) {
      this.setSearchString(val)
    },
    onSearchClick() {
      EventBus.$emit('onSearchButtonClick')
    }
  }
}
</script>
